import React from "react";
import { COLORS } from "../constants";
import { pill, fontSerif } from "./styles";

/**
 * BellIndicator — small "bell tolls on the hour" pill.
 * Renders inline (inside the right-stack flex) by default so it never
 * collides with anything else. `inline=false` keeps the original absolute
 * fallback for any future standalone usage.
 */
export default function BellIndicator({ visible, inline = true, compact = false }) {
  if (!visible) return null;

  const fontSize = compact ? 10 : 11;
  const padding = compact ? "5px 12px" : "6px 14px";

  const wrapperStyle = inline
    ? {
        ...pill,
        padding,
        color: COLORS.gold,
        fontFamily: fontSerif,
        fontSize,
        letterSpacing: 2,
        textTransform: "uppercase",
        display: "flex",
        alignItems: "center",
        gap: 8,
        whiteSpace: "nowrap",
        pointerEvents: "auto",
      }
    : {
        position: "absolute",
        top: 284,
        right: 24,
        ...pill,
        padding,
        color: COLORS.gold,
        fontFamily: fontSerif,
        fontSize,
        letterSpacing: 2,
        textTransform: "uppercase",
        display: "flex",
        alignItems: "center",
        gap: 8,
      };

  return (
    <div data-testid="zone-bell-indicator" style={wrapperStyle}>
      <span
        style={{
          width: 6,
          height: 6,
          borderRadius: "50%",
          background: COLORS.gold,
          boxShadow: `0 0 8px ${COLORS.gold}`,
        }}
      />
      Bell tolls on the hour
    </div>
  );
}
